/* 요금제 개폐 스위치 (2026-10-15 김현비).
   요금제 없이 전부 무료로 운영하기로 해서 메뉴·/pricing·마이페이지 결제 탭을 숨겼다.
   결제·구독 코드와 DB 는 그대로 있으니, 다시 열려면 이 값만 true 로 바꾸면 된다. */
export const PRICING_OPEN = false;

/* 저장 규칙 (2026-10-15 김현비, 클릭커스토리와 같은 방식).
   - 디자인 10개, STL 10개를 따로 센다. 휴지통에 있는 것은 세지 않는다.
   - 마지막으로 저장한 뒤 30일이 지나면 자동 삭제된다. 다시 저장하면 30일이 새로 시작된다.
   - 휴지통에 들어간 것은 30일 뒤 영구 삭제된다.
   자동 삭제는 서버(server/main.py 의 storage_retention_loop)가 한다. */
export const DESIGN_SAVE_LIMIT = 10;
export const FILE_SAVE_LIMIT = 10;
export const STORAGE_RETENTION_DAYS = 30;
